<template>
  <div class="companies">
    <section class="section-header">
      <h1>
        <Link to="/admin/users">Admin</Link>
        <Link to="/admin/users">{{ $t('meta.users') }}</Link>
        {{ user.first_name }} {{ user.last_name }}
      </h1>
      <div class="meta">
        <button @click="deleteUser" class="button button-red button-small button-round">
          {{ $t('companies.deleteUser') }}
        </button>
        <Link to="/admin/users" class="button button-grey button-round button-small">{{
          $t('companies.allUsers')
        }}</Link>
      </div>
    </section>

    <div class="body-content cf">
      <div class="entries-wrap">
        <admin-nav></admin-nav>
        <div class="body">
          <LoadingSpinner v-if="loading" full />
          <div v-else>
            <UserBaseData :templateMode="'edit'" :user="user" :onSubmitBaseData="updateUser" />
            <div class="content-wrap">
              <header class="content-header cf">
                <h3>{{ $t('meta.companies') }}</h3>
                <div class="header-meta">
                  <Link
                    :to="`/admin/users/${$route.params.uuid}/companies/new`"
                    class="button button-green button-small button-round"
                    >{{ $t('companies.addCompany') }}</Link
                  >
                </div>
              </header>
              <div class="content-body">
                <div v-if="user && user.company_users.length > 0">
                  <Table>
                    <template #header>
                      <th>{{ $t('admin.user.name') }}</th>
                      <th>{{ $t('admin.user.role') }}</th>
                      <th class="table__th-actions">{{ $t('meta.actions') }}</th>
                    </template>
                    <template #body>
                      <tr v-for="companyUser in user.company_users" :key="companyUser.uuid">
                        <td>{{ companyUser.company_name }}</td>
                        <td>{{ mapUserRoles(companyUser.roles) }}</td>
                        <td class="table__actions">
                          <Link
                            :to="`/admin/users/${$route.params.uuid}/companies/${companyUser.company_uuid}`"
                            class="table__action-button"
                            ><span class="material-icons">edit</span></Link
                          >
                          <button @click="deleteCompanyUser(companyUser)" class="table__action-button">
                            <span class="material-icons">delete</span>
                          </button>
                        </td>
                      </tr>
                    </template>
                  </Table>
                </div>
                <div v-else>
                  <p class="alert alert-info">
                    {{ $t('companies.noCompaniesForUser') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'
import Table from '@/components/Table'
import UserBaseData from '@/components/UserBaseData'
import AdminNav from '@/components/admin_nav'

import adminsApi from '@/api/admin'
import companyUsersApi from '@/api/companyUsers'

export default {
  name: 'admin_user',
  inject: ['showPopup'],
  components: {
    AdminNav,
    UserBaseData,
    LoadingSpinner,
    Table,
  },
  data() {
    return {
      loading: true,
      user: {},
    }
  },
  methods: {
    mapUserRoles(roles) {
      return roles ? roles.map(role => this.$t(`meta.roles.${role}`)).join(', ') : '-'
    },
    async updateUser(userData) {
      const newUser = await adminsApi.updateUser(this.$route.params.uuid, userData)
      if (newUser) {
        this.user = newUser
      }
    },
    async deleteUser() {
      if (!(await this.showPopup({ content: this.$t('admin.user.deleteUserConfirmation'), type: 'confirm' }))) return

      const deleteSuccessful = await adminsApi.deleteUser(this.$route.params.uuid)

      if (deleteSuccessful) {
        this.$router.push('/admin/users')
      }
    },
    async deleteCompanyUser(companyUser) {
      if (!(await this.showPopup({ content: this.$t('admin.user.deleteCompanyUserConfirmation'), type: 'confirm' })))
        return

      const deleteSuccessful = await companyUsersApi.delete(companyUser.uuid)

      if (deleteSuccessful) {
        this.user = await adminsApi.getUser(this.$route.params.uuid)
      }
    },
  },
  async mounted() {
    this.user = await adminsApi.getUser(this.$route.params.uuid)
    this.loading = false
  },
}
</script>
